import { getFakeNetworkStatus } from '../storybook/storybook-settings'

export type ImageLoader = (src: string) => Promise<void>

// Preloads an image, awaiting the storybook fake-network delay first so the
// <img> tag doesn't start its own request before the placeholder has had time
// to paint. The browser's HTTP cache dedupes the subsequent <img src={src}>
// with this preload, so the full image appears instantly once we resolve.
async function defaultLoader(src: string): Promise<void> {
  const status = getFakeNetworkStatus(src)
  if (status === 'slow') {
    await new Promise((resolve) => {
      setTimeout(resolve, 2500)
    })
  }
  if (status === 'fail') {
    throw new Error(`loadImage: fake network failure for ${src}`)
  }
  return new Promise<void>((resolve, reject) => {
    const img = new window.Image()
    img.addEventListener('load', () => {
      if (typeof img.decode === 'function') void img.decode().then(resolve, reject)
      else resolve()
    })
    img.addEventListener('error', () => {
      reject(new Error(`loadImage: failed to load ${src}`))
    })
    img.src = src
  })
}

let current: ImageLoader = defaultLoader

export const loadImage = (src: string, loader?: ImageLoader) =>
  (loader ?? current)(src)

export const setLoadImage = (f: ImageLoader) => {
  current = f
}
